module.exports = new __parcel__URL__("duck-hunt.c4203f51.jpg").toString();